import React from 'react';
import Table from '@mui/material/Table';
import LoadingContainer from 'Containers/LoadingContainer';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import TableRow from '@mui/material/TableRow';
import useTranslation from 'Hooks/useTranslation';
import Row from './Row';
import style from './style';

const { tableContainerStyle, tableStyle, tableHead, tableCellStyle } = style;

export default function BasicTable({
  headers = [],
  information = [],
  limitColumns = information.length,
  thereIsComponent = null,
  expandible = null,
  configButton = [],
  configButtonEvents = [],
  configButtonModals = [],
  editButton = false,
  editButtonEvent = () => {},
  children,
  isLoading,
}) {
  const { t2 } = useTranslation('Table');

  if (information.length === 0 || isLoading)
    return <LoadingContainer isLoading={isLoading}>{t2('NoData')}</LoadingContainer>;

  return (
    <div className="col" style={{ flex: 1, width: '100%' }}>
      <TableContainer component={Paper} style={tableContainerStyle} elevation={0} className="col">
        <Table sx={tableStyle}>
          <TableHead sx={tableHead}>
            <TableRow>
              {headers.map(header => (
                <TableCell key={header} align="center" sx={tableCellStyle}>
                  {header}
                </TableCell>
              ))}
              {configButton.length ? <TableCell align="center" /> : null}
            </TableRow>
          </TableHead>
          <TableBody>
            {information.map(row => (
              <Row
                key={row}
                row={row}
                limit={limitColumns}
                thereIsComponent={thereIsComponent}
                expandible={expandible}
                configButtonEvents={configButtonEvents}
                configButtonModals={configButtonModals}
                configButton={configButton}
                editButton={editButton}
                editButtonEvent={editButtonEvent}
              />
            ))}
          </TableBody>
        </Table>
        {children}
      </TableContainer>
    </div>
  );
}
